/* trademarks: the portfolio list (`tm`), one trademark's dossier (`tmd`) and
 * the add form (`tmAdd`) — translated in the Wave 3 pass (2026-09-30). */
export default {
  tm: {
    title: 'Mes marques',
    subtitle:
      'Gérez les marques surveillées, leurs juridictions, leur statut juridique et leur surveillance.',
    filters: 'Filtres',
    add: 'Ajouter une marque',
    kpi: {
      label: 'Aperçu du portefeuille',
      total: 'Marques au total',
      thisMonth: 'ce mois-ci',
      noneThisMonth: 'Aucun ajout ce mois-ci',
      monitored: 'Surveillance active',
      ofPortfolio: 'du portefeuille sous surveillance',
      openMatches: 'Correspondances à examiner',
      openMatchesHint: "Sur l'ensemble du portefeuille",
      openMatchesNone: 'Rien en attente',
      registries: 'Registres couverts',
      registriesNone: 'Aucune surveillance configurée',
    },
    filter: {
      search: 'Recherche',
      searchPlaceholder: 'Marque ou titulaire',
      monitoring: 'Surveillance',
      monitored: 'Surveillées',
      notMonitored: 'Non surveillées',
      registry: 'Registre',
      noRegistries: 'Aucun registre configuré pour le moment.',
      classes: 'Classes de Nice',
      classesHint: 'Classes présentes sur cette page, les plus fréquentes en premier.',
      type: 'Type de marque',
      reset: 'Réinitialiser',
      apply: 'Appliquer',
    },
    chip: {
      registry: 'Registre : {code}',
      class: 'Classe {n}',
      search: 'Recherche : {q}',
    },
    sort: {
      label: 'Trier les marques',
      title: 'Nom (A–Z)',
      titleDesc: 'Nom (Z–A)',
      recent: 'Ajoutées récemment',
      registered: "Date d'enregistrement, la plus récente d'abord",
      expiring: "Date d'expiration, la plus proche d'abord",
    },
    bulk: {
      confirmTitle: 'Supprimer {n} marque ? | Supprimer {n} marques ?',
      cannotUndo: 'Cette action est irréversible.',
      goesWith:
        'Leurs périmètres de surveillance, leurs documents et leur historique de correspondances sont supprimés avec elles.',
      partial: '{done} sur {n} supprimées',
      partialSub: "{n} n'a pas pu être supprimée. | {n} n'ont pas pu être supprimées.",
      done: '{n} marque supprimée | {n} marques supprimées',
    },
    shown: '{n} sur {total} marque | {n} sur {total} marques',
    filtersActive: '{n} filtre actif | {n} filtres actifs',
    searchPlaceholder: 'Rechercher des marques…',
    col: {
      trademark: 'Marque',
      owner: 'Titulaire',
      juris: 'Pays',
      classes: 'Classes de Nice',
      monitoring: 'Surveillance',
      status: 'Statut',
      review: 'Examen',
    },
    empty: {
      title: 'Aucune marque ne correspond à vos filtres',
      message: 'Retirez le registre ou la classe sélectionnés, ou cherchez un autre nom.',
      reset: 'Réinitialiser les filtres',
    },
    page: {
      showing: 'Affichage',
      ofTotal: 'sur {total} marque | sur {total} marques',
      prev: 'Page précédente',
      next: 'Page suivante',
    },
    preview: {
      label: 'Aperçu de la marque sélectionnée',
      noNumber: 'Sans numéro',
      reg: 'Enr. {date}',
      close: "Fermer l'aperçu",
      owner: 'Titulaire',
      country: 'Pays',
      watchedOn: 'Surveillée sur',
      pausedOn: 'Suspendue : {list}',
      classes: 'Classes de Nice',
      type: 'Type',
      status: 'Statut',
      monitoring: 'Surveillance',
      awaiting: "correspondance en attente d'examen | correspondances en attente d'examen",
      openCases: '{n} dossier ouvert | {n} dossiers ouverts',
      dossier: 'Voir le dossier complet',
      openMonitoring: 'Ouvrir la surveillance',
    },
    monitoring: {
      active: 'Surveillance active',
      paused: 'Surveillance suspendue',
      none: 'Non surveillée',
    },
    monitoringTag: {
      active: 'Active',
      paused: 'Suspendue',
      none: 'Non surveillée',
    },
    row: {
      select: 'Sélectionner {name}',
      logoAlt: 'Logo de {name}',
      toReview: '{n} à examiner',
      clear: 'Rien',
      open: 'Ouvrir le dossier de la marque',
    },
    status: {
      registered: 'Enregistrée',
      pending: 'En cours',
      opposition: 'En opposition',
      under_review: 'En examen',
      filed: 'Déposée',
      published: 'Publiée',
      opposed: 'Faisant l’objet d’une opposition',
      cancellation_procedure: 'En annulation',
      expired: 'Expirée',
      refused: 'Refusée',
      withdrawn: 'Retirée',
    },
    type: {
      wordmark: 'Verbale',
      figurative: 'Figurative',
      combined: 'Complexe',
      sound: 'Sonore',
      other: 'Autre',
    },
  },

  tmd: {
    back: 'Retour au portefeuille',
    logoAlt: 'Logo de {name}',
    eyebrow: 'Marque protégée',
    toReviewTitle: "Correspondances relevées par l'IA que personne n'a encore examinées",
    regShort: 'Enr.',
    monitoring: 'Surveillance par IA',
    monitoringActive: 'Active · {list}',
    uploading: 'Envoi…',
    upload: 'Ajouter un document',
    openMonitoring: 'Ouvrir la surveillance',
    createOpposition: "Créer un dossier d'opposition",
    label: 'Dossier de la marque',
    sections: 'Sections du dossier',
    tab: {
      overview: 'Aperçu',
      monitoring: 'Surveillance',
      matches: 'Correspondances',
      oppositions: 'Oppositions',
      documents: 'Documents',
    },
    details: {
      title: "Données d'enregistrement",
      type: 'Type de marque',
      country: "Pays d'enregistrement",
      number: "N° d'enregistrement ou de demande",
      status: 'Statut',
      filed: 'Déposée le',
      registered: 'Enregistrée le',
      expires: 'Expire le',
      owner: 'Titulaire',
      classes: 'Classes de Nice',
      description: 'Description',
    },
    scopes: {
      title: 'Périmètre de surveillance',
      count: '{n} registre | {n} registres',
      emptyTitle: "Cette marque n'est pas surveillée",
      empty:
        "Aucun registre n'a été choisi pour cette marque : les nouvelles publications ne sont pas comparées avec elle.",
      registry: 'Registre',
      state: 'État',
      lastScan: 'Dernière analyse',
      active: 'Active',
      paused: 'Suspendue',
      awaiting: 'En attente de la première analyse (trois mois en arrière)',
      never: 'Jamais analysée',
      feedFallback: 'Source {id}',
    },
    matches: {
      title: 'Correspondances liées',
      awaiting: '{n} à examiner',
      found: 'Marque trouvée',
      registry: 'Registre',
      decidedBy: 'Décidé par',
      risk: 'Risque',
      window: 'Délai',
      rule: 'Règle de correspondance',
      review: 'Examiner',
      emptyTitle: 'Aucune correspondance pour cette marque',
      empty:
        "Rien de ce qui a été publié dans les registres surveillés n'a encore été jugé similaire à cette marque.",
      more: "Les {n} dont le délai d'opposition est le plus proche sont affichées. Les autres figurent sur la page de surveillance, sous cette marque.",
      closesToday: "Expire aujourd'hui",
      closedDays: 'Expiré depuis {n} jour | Expiré depuis {n} jours',
      closedMonths: 'Expiré depuis {n} mois | Expiré depuis {n} mois',
      closedYears: 'Expiré depuis {n} an | Expiré depuis {n} ans',
    },
    docs: {
      title: 'Documents',
      count: '{n} fichier | {n} fichiers',
      emptyTitle: 'Aucun document pour le moment',
      empty: "Certificats d'enregistrement, preuves d'usage et correspondance sont conservés ici.",
      uploadFirst: 'Ajouter un fichier',
      file: 'Fichier',
      kind: 'Type',
      size: 'Taille',
      added: 'Ajouté le',
      remove: 'Supprimer {name}',
      rejected: 'refusé',
      notUploaded: "{n} fichier n'a pas été envoyé | {n} fichiers n'ont pas été envoyés",
      uploaded: '{n} fichier envoyé | {n} fichiers envoyés',
      confirmTitle: 'Supprimer {name} ?',
      confirmBody: 'Le fichier est supprimé définitivement. Cette action est irréversible.',
      deleted: 'Fichier supprimé',
      deleteFailed: "Le fichier n'a pas pu être supprimé",
    },
    rail: {
      label: 'Synthèse de la protection',
      title: 'Synthèse de la protection',
      watchedOn: 'Surveillée sur',
      none: 'Aucun',
      classes: 'Classes de Nice',
      noneRecorded: 'Aucune enregistrée',
      toReview: 'Correspondances à examiner',
      openCases: 'Dossiers ouverts',
    },
  },

  tmAdd: {
    crumb: 'Ajouter une marque',
    title: 'Ajouter une marque',
    subtitle:
      'Enregistrez une marque que vous protégez et choisissez les registres à surveiller pour détecter les conflits.',
    creating: 'Création…',
    create: 'Créer la marque',
    loadFailed: 'Impossible de charger : {list}.',
    failedPart: {
      clients: 'les clients',
      registries: 'les registres',
      classes: 'les classes de Nice',
    },
    workspace: "Formulaire d'ajout de marque",
    required: 'Obligatoire',
    example: 'p. ex. {value}',
    err: {
      title: 'Le nom de la marque est obligatoire',
      titleShort: 'Au moins {n} caractères',
      client: 'Choisissez le client titulaire de cette marque',
      country: "Le pays d'enregistrement est obligatoire",
      type: 'Choisissez un type de marque',
      classes: 'Choisissez au moins une classe de Nice',
      incomplete: 'Veuillez remplir les champs obligatoires',
    },
    mark: {
      title: 'La marque',
      sub: 'Ce qui est protégé, et qui en est titulaire.',
      name: 'Nom de la marque',
      namePlaceholder: 'La marque telle que déposée',
      country: "Pays d'enregistrement",
      countryPick: 'Choisir un pays…',
      countryHint: 'Détermine quel registre national peut être surveillé.',
      owner: 'Titulaire (client)',
      ownerPick: 'Choisir un client…',
      clientCount: '{n} client dans votre espace | {n} clients dans votre espace',
      addClient: 'en ajouter un',
      type: 'Type de marque',
      description: 'Description',
      descriptionPlaceholder:
        'Les produits et services avec vos propres mots, ou tout ce que la personne suivante doit savoir.',
    },
    typeHint: {
      word: 'Texte seul : le nom lui-même est protégé.',
      figurative: 'Un logo ou un signe sans élément verbal.',
      combined: 'Éléments verbaux et figuratifs réunis.',
      sound: 'Un jingle ou une signature sonore.',
      other: 'Forme, couleur, mouvement, position.',
    },
    registration: {
      title: 'Enregistrement',
      sub: "Facultatif : une marque peut être surveillée avant d'être enregistrée.",
      application: 'N° de demande',
      registration: "N° d'enregistrement",
      filed: 'Déposée le',
      registered: 'Enregistrée le',
      expires: 'Expire le',
    },
    scopes: {
      title: 'Où surveiller',
      sub: 'Chaque registre choisi est analysé pour détecter les conflits avec cette marque.',
      selected: '{n} sélectionné | {n} sélectionnés',
      hint: "Une marque sans registre choisi est conservée mais n'est jamais analysée.",
      inactive: 'Actuellement inactif',
      countryFirst: "Choisissez d'abord le pays",
      onlyFor: 'Uniquement pour les marques {code}',
      noSource: "Votre cabinet n'a configuré aucune source pour ce registre",
    },
    feedKind: {
      world: 'International (système de Madrid)',
      europe: 'Union européenne',
      national: 'Office national',
    },
    classes: {
      title: 'Classes de Nice',
      sub: 'Les produits et services couverts par la marque. Les conflits sont appréciés au regard de ces classes.',
      search: 'Rechercher parmi les 45 classes par numéro ou par libellé…',
      searchLabel: 'Rechercher une classe de Nice',
    },
    next: {
      label: 'Aide',
      title: 'Et ensuite',
      now: 'Immédiatement.',
      nowText: 'La marque est rattachée à son client et apparaît dans le portefeuille.',
      scan: 'Première analyse.',
      scanText:
        "Chaque nouveau périmètre commence par une analyse des trois derniers mois — le délai d'opposition — pour ne rien manquer de ce qui est déjà publié.",
      after: 'Ensuite.',
      afterText:
        "Ajoutez le certificat d'enregistrement et les éventuelles preuves dans le dossier de la marque.",
    },
    actions: 'Actions du formulaire',
    unsaved: "Rien n'est enregistré tant que vous n'avez pas créé la marque.",
    created: 'Marque créée',
    createdWatched:
      '{name} est désormais surveillée sur {n} registre. | {name} est désormais surveillée sur {n} registres.',
    createdUnwatched:
      '{name} a été ajoutée. Aucun périmètre de surveillance choisi pour le moment.',
    createFailed: "La marque n'a pas pu être créée",
  },
} as const
